var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{key:"success",staticClass:"alert",class:'alert-'+_vm.alertType,staticStyle:{"position":"fixed","left":"50%","transform":"translateX(-50%)"}},[_vm._v(_vm._s(_vm.msg))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ea4ad5c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = 698
// module chunks = 0